// extracted by mini-css-extract-plugin
export default {"container":"banner-faq_container__NMf5S","perguntas-faq":"banner-faq_perguntas-faq__oK2fz"};